import { TitleRowTabBeneficiaries } from 'components/TitleRowTabBeneficiaries';
import { useGetTabEmployedsQuery } from 'redux/Api/employedsWorkSupportApi/employedsWorkSupportApi';
import { Nothing } from 'components/Nothing';
import { LoadingSkeleton } from 'components/LoadingSkeleton';
import { DocumentsEmployedsItem } from 'ui/DocumentsEmployedsItem';
import styles from './Documents.module.scss';
import {
  QueryParamsTabEmployedsType,
  ResponseTabEmployedsDocumentsType,
} from 'redux/Api/employedsWorkSupportApi/type';

export const Documents = ({ id = 0, title }: QueryParamsTabEmployedsType) => {
  const { data, isLoading, error } = useGetTabEmployedsQuery({ id, title });
  const dataDocuments = ['Дата', 'Тип', 'Подписано'];

  return (
    <div className={styles.root}>
      <TitleRowTabBeneficiaries data={dataDocuments} title='documentsEmployeds' />
      {error || !data?.length ? (
        <Nothing
          style={{ height: '640px' }}
          title={error ? 'Ошибка, попробуйте позже' : 'Ничего не найдено'}
        />
      ) : isLoading ? (
        <LoadingSkeleton tabDetails />
      ) : (
        (data as ResponseTabEmployedsDocumentsType[])?.map((elem, i) => (
          <DocumentsEmployedsItem doc={elem} key={i} />
        ))
      )}
    </div>
  );
};
